export default __webpack_public_path__ + "static/media/contato.77b858c4.svg";